"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const roLocaleData = require("i18next-icu/locale-data/ro");
exports.default = roLocaleData;
//# sourceMappingURL=ro.js.map